import { FunctionComponent } from 'react';

import styles from './Procedures.module.sass';
import RAStep from './Procedures/RAStep';
import TitleWithSeparator from '../common/TitleWithSeparator';
import { CompanyCDN } from '../../../utils/url';

const Procedures: FunctionComponent = () => {
    return (
        <div className={styles.container}>
            <TitleWithSeparator>How Return Assurance works</TitleWithSeparator>
            <div className={styles.steps}>
                <RAStep
                    image={CompanyCDN.url('/assets/images/about-ra/step-01.png')}
                    title="ADD SEEL RETURN ASSURANCE"
                    description="When checking out, add Return Assurance to non-refundable purchases for just a small fee."
                />
                <RAStep
                    image={CompanyCDN.url('/assets/images/about-ra/step-02.png')}
                    title="CHECKOUT WITH PEACE OF MIND"
                    description="Complete your purchase worry-free, knowing that Return Assurance has you covered with a flexible return policy."
                />
                <RAStep
                    image={CompanyCDN.url('/assets/images/about-ra/step-03.png')}
                    title="RETURN FOR ANY REASON"
                    description="Return if your purchase doesn’t go as planned and get a full refund."
                />
            </div>
        </div>
    );
};

export default Procedures;
